import axios from "axios"
import { CollectionQuery } from "../../../models/collection.model"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { OWNER_ENDPOINT } from "../owner.endpoint"

export const exportOwners = async (query: CollectionQuery) => {
  try {
    const url = `${OWNER_ENDPOINT.export}?${collectionQueryBuilder(query)}`

    const response = await axios.get(url, {
      responseType: "arraybuffer",
       headers: {
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`,
      }
    })

    return response.data // This will be the ArrayBuffer
  } catch (error) {
    console.error("Error fetching export pretrips:", error)
    throw error // Re-throw the error for the caller to handle
  }
}
